import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { TaskStatus } from 'src/app/components/tasks/TaskStatus';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  LoadedData = false;
  editingSearch = false;
  current_selected_search: any = {
    title: ''
  }
  selected_guid = 'GUID';
  search = {
    title: '',
    body: '',
    is_update: false,
    guid: ''
  }
  searches: any = [];

  rulesets: any = [];
  rules: any = [];

  @Input() first_rule: any;
  @Input() fields = [];
  @Input() show_date_range = false;
  @Input() type = '';
  @Input() get_groups = false;
  @Input() get_tags = false;
  @Input() get_status = false;
  @Input() get_internal_status = false;
  @Input() get_team_members = false;


  @Input() start_date: Date;
  @Input() end_date: Date;


  constructor(private apiService: ApiService, private modalController: ModalController, public globalService: GlobalService) { }

  ngOnInit() {
    console.log("Start Date: ", this.start_date);
    if (this.start_date) {
      const pad = (n: number) => n.toString().padStart(2, '0');
      const yyyy = this.start_date.getFullYear();
      const mm = pad(this.start_date.getMonth() + 1);
      const dd = pad(this.start_date.getDate());
      this.start_date = `${yyyy}-${mm}-${dd}` as any;
    }
    if (this.end_date) {
      const pad = (n: number) => n.toString().padStart(2, '0');
      const yyyy = this.end_date.getFullYear();
      const mm = pad(this.end_date.getMonth() + 1);
      const dd = pad(this.end_date.getDate());
      this.end_date = `${yyyy}-${mm}-${dd}` as any;
    }
    console.log("End Date: ", this.end_date);
    this.GetData();
  }

  async GetData() {
    this.GetSearches();
    if(this.get_status) await this.GetStatus();
    //if(this.get_internal_status) await this.GetInternalStatus();
    if(this.get_tags) await this.GetTags();
    if(this.get_groups) await this.GetGroups();
    if(this.get_team_members) await this.GetTeamMembers();
    this.LoadedData = true;
  }

  async GetTeamMembers() {
    let data: any = await this.apiService.get('team_members');
    for (var i = 0; i < data.data.length; i++) {
      data.data[i].name = data.data[i].display_name;
      data.data[i].value = data.data[i].guid;
    }
    this.fields[this.fields.findIndex(item => item.name === "Team Members")].options = data.data;
    //this.config.fields.team_members.options = data.data;
    console.log(data.data);
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async GetStatus() {
    this.fields[this.fields.findIndex(item => item.name === "Status")].options = this.globalService.EnumToArrayTwo(TaskStatus);
    console.log("STATUS FIELDS: ",this.fields[this.fields.findIndex(item => item.name === "Status")].options);
  }

  async GetInternalStatus() {
      const internalStatusOptions = [
        { name: 'Planning', value: 'Planning' },
        { name: 'In Progress', value: 'In Progress' },
        { name: 'Under Review', value: 'Under Review' },
        { name: 'On Hold', value: 'On Hold' },
        { name: 'Completed', value: 'Completed' },
        { name: 'Cancelled', value: 'Cancelled' }
      ];
      this.fields[this.fields.findIndex(item => item.name === "Internal Status")].options = internalStatusOptions;
      console.log("Internal STATUS FIELDS: ",this.fields[this.fields.findIndex(item => item.name === "Internal Status")].options);
  }

  async GetTags() {
      let data: any = await this.apiService.GetTags(this.type);
      console.log("TAGS DATA: ",data);
      for (var i = 0; i < data.data.length; i++) {
        data.data[i].name = data.data[i].title;
        data.data[i].value = data.data[i].guid;
      }
      this.fields[this.fields.findIndex(item => item.name === "Tags")].options = data.data;
      console.log("TAGS FIELDS: ",this.fields[this.fields.findIndex(item => item.name === "Tags")].options);
  }

  async GetGroups() {
    let data: any = await this.apiService.GetGroups(this.type);
    for (var i = 0; i < data.data.length; i++) {
      data.data[i].name = data.data[i].title;
      data.data[i].value = data.data[i].guid;
    }
    this.fields[this.fields.findIndex(item => item.name === "Groups")].options = data.data;
  }

  async SelectedSearchChange(value: any) {
    let index = this.globalService.GetArrayIndex(this.searches, value.target.value);
    console.log(this.searches[index]);
    if (index >= 0) {
      console.log("STRN",JSON.stringify(JSON.parse(this.searches[index].query)));
      this.rulesets = JSON.parse(this.searches[index].query);
      console.log("Rulesets: ", this.rulesets);
      this.current_selected_search = this.searches[index];
      this.editingSearch = true;
    }
    else {
      this.editingSearch = false;
    }
    console.log("Current Selected Search: ", this.current_selected_search);

  }

  async GetSearches() {
    let data: any = await this.apiService.get(`searches/${this.type}`);
    this.searches = data.data;
    if(!this.searches) this.searches = [];
  }

  async SaveSearch() {
    let Indata = {
      title: this.current_selected_search.title,
      query: JSON.stringify(this.rulesets)
    }

    let data: any = await this.apiService.post(`searches/${this.type}`, Indata);
    console.log(data);
    this.searches.push(data.data[0]);
    this.current_selected_search = data.data[0];
    this.editingSearch = true;
    this.selected_guid = this.current_selected_search.guid;
  }

  async UpdateSearch() {
    let Indata = {
      title: this.current_selected_search.title,
      query: JSON.stringify(this.rulesets)
    }
    let data: any = await this.apiService.put(`searches/${this.type}/${this.current_selected_search.guid}`, Indata);
  }

  async DeleteSearch() {
    let data: any = await this.apiService.delete(`searches/${this.type}/${this.current_selected_search.guid}`, null);
    let index = this.globalService.GetArrayIndex(this.searches, this.current_selected_search.guid);
    this.searches.splice(index, 1);
    this.current_selected_search = { title: '' };
    this.editingSearch = false;
    this.selected_guid = 'GUID';

  }

  async Search() {
    console.log("Rule Set", this.rulesets);
    let data = {
      start_date: typeof this.start_date === 'string' ? new Date(this.start_date) : this.start_date,
      end_date: typeof this.end_date === 'string' ? new Date(this.end_date) : this.end_date,
      rules: this.rulesets
    }
    this.modalController.dismiss(data);
  }

  async OnSearchTitleChange(title) {
    var selected_search = this.searches.find(search => search.title.toLowerCase() == title.toLowerCase());
    if (selected_search) {
      this.search.is_update = true;
      this.search.body = selected_search.body;
      this.search.guid = selected_search.guid;
    }
    else {
      this.search.is_update = false;
    }
  }

  async AddRule(rule) {
    let copy_first = JSON.stringify(this.first_rule);

    rule.push(JSON.parse(copy_first));
  }

  async AddRuleset() {
    let push_data: any = {
      rules: [],
      selector: 'or'
    }
    push_data.rules.push(JSON.parse(JSON.stringify(this.first_rule)));
    this.rulesets.push(push_data);
    
  }

  async RemoveRule(rule_set_index,rule_index) {
    console.log(this.rulesets[rule_set_index]);
    this.rulesets[rule_set_index].rules.splice(rule_index,1);
    if(this.rulesets[rule_set_index].rules.length == 0) {
      this.rulesets.splice(rule_set_index, 1);
    }
  }

  getSearchDescription(): string {
    if (!this.rulesets || this.rulesets.length === 0) return '';

    const oprLabel = (opr: string, type: string): string => {
      if (type === 'date') {
        if (opr === 'equals') return 'is on';
        if (opr === 'less') return 'is before';
        if (opr === 'greater') return 'is after';
      }
      if (opr === 'equals') return type === 'boolean' ? 'is' : 'equals';
      if (opr === 'greater') return 'is greater than';
      if (opr === 'less') return 'is less than';
      if (opr === 'contains') return 'contains';
      if (opr === 'contains-any') return 'includes any of';
      if (opr === 'contains-all') return 'includes all of';
      if (opr === 'contains-none') return 'does not contain';
      return opr;
    };

    const valueLabel = (rule: any): string => {
      if (rule.type === 'boolean') return rule.value ? 'Yes' : 'No';
      if (rule.type === 'date') {
        const d = new Date(rule.value + 'T00:00:00');
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      }
      if (rule.type === 'category' && Array.isArray(rule.value) && rule.value.length > 0) {
        const fieldIdx = this.fields.findIndex(f => f.name === rule.field);
        const options = fieldIdx >= 0 ? (this.fields[fieldIdx].options || []) : [];
        const names = rule.value.map((v: any) => {
          const opt = options.find((o: any) => o.guid === v || o.value === v);
          return opt ? (opt.name || opt.display_name || opt.value || v) : v;
        });
        return names.join(', ');
      }
      return `"${rule.value}"`;
    };

    const ruleDesc = (rule: any): string =>
      `${rule.field} ${oprLabel(rule.opr, rule.type)} ${valueLabel(rule)}`;

    const groups = this.rulesets
      .filter(rs => rs.rules && rs.rules.length > 0)
      .map(rs => rs.rules.map(ruleDesc).join(' and '));

    if (groups.length === 0) return '';
    if (groups.length === 1) return `Where ${groups[0]}.`;
    return `Where (${groups.join(') or (')}).`;
  }

  //Checks to make sure all rules have sometihng and that thing is not empty before we can search
  HasEmptyRules() {
    for (var i = 0; i < this.rulesets.length; i++) {
      if(this.rulesets[i].rules.length == 0) {
        return true;
      } else {
        for (var b = 0; b < this.rulesets[i].rules.length; b++) {
          if(!this.rulesets[i].rules[b].value || this.rulesets[i].rules[b].value.length == 0) {
            return true;
          }
        }
      }
    }
    return false;
  }

}
